namespace $ { $mol_style_attach( "mol/textarea/demo/demo.view.css",
 "[mol_textarea_demo] {\n\talign-self: stretch;\n}\n\n[mol_textarea_demo_inputs] {\n\tpadding: var(--mol_gap_block);\n}\n"
) }